import React from 'react';
import { Products } from '../../../hooks/api-methods/get-products';
import UploadsListView from '../Upload/galleryView';
import MyMasonry from '../../../components/Mansory/Mansory';

interface ProductSidebarProps {
  isOpen: boolean;
  title: string;
  product: Products;
  isSubmitting: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onSelectImages?: (urls: string[]) => void; // Optional handler for selecting multiple images
}

const ProductSidebar: React.FC<ProductSidebarProps> = ({
  isOpen,
  title,
  product,
  isSubmitting,
  onClose,
  onSubmit,
  onChange,
  onSelectImages,
}) => {
  const [selectedImages, setSelectedImages] = React.useState<string[]>(product.images ?? []);
  const handleSelectImages = (urls: string[]) => {
    setSelectedImages(urls);
    onSelectImages?.(urls);
  };

  return (
    <div className={`product-sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-header">
        <h3>{title}</h3>
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>
      </div>

      <form className="sidebar-form" onSubmit={onSubmit}>
        <div className="flex-row-align">
          <label className="w-100">
            Title
            <input type="text" name="title" value={product.title} onChange={onChange} required />
          </label>

          <label className="w-100">
            Subject
            <input
              type="text"
              name="subject"
              value={product.subject}
              onChange={onChange}
              required
            />
          </label>
        </div>
        <div className="flex-row-align">
          <label className="w-100">
            Location
            <input
              type="text"
              name="location"
              value={product.location}
              onChange={onChange}
              required
            />
          </label>
          <label>
            Duration
            <input
              type="text"
              name="duration"
              value={product.duration}
              onChange={onChange}
              required
            />
          </label>
        </div>

        <label>
          Description
          <textarea name="desc" value={product.desc} onChange={onChange} rows={4} />
        </label>

        {/* Display selected images in a Masonry grid */}
        {selectedImages.length > 0 && (
          <div className="selected-images-grid w-100">
            <p>Selected Images:</p>
            <MyMasonry
              items={selectedImages}
              renderItem={(url) => (
                <div className="flex-row-align">
                  <img src={url} alt="Selected" className="selected-image-preview" />
                  <p className="p-hidden">{url}</p>
                </div>
              )}
            />
          </div>
        )}

        {/* Image selection component */}
        {onSelectImages && (
          <div className="uploads-selector w-100">
            <p>Select images from your storage:</p>
            <UploadsViewWrapper onSelectImages={handleSelectImages} />
          </div>
        )}

        <button type="submit" className="btn-primary w-100" disabled={isSubmitting}>
          {isSubmitting ? 'Saving...' : 'Save product'}
        </button>
      </form>
    </div>
  );
};

export default ProductSidebar;

/* ---------------------------------- */
/* Uploads Wrapper to return selected images */
/* ---------------------------------- */
interface UploadsViewWrapperProps {
  onSelectImages: (urls: string[]) => void;
}

const UploadsViewWrapper: React.FC<UploadsViewWrapperProps> = ({ onSelectImages }) => {
  const [selectedImages, setSelectedImages] = React.useState<string[]>([]);

  const handleSelect = (url: string) => {
    setSelectedImages((prev) => {
      const newSelection = prev.includes(url) ? prev.filter((u) => u !== url) : [...prev, url];
      onSelectImages(newSelection);
      return newSelection;
    });
  };

  return <UploadsListView selectMode selectedImages={selectedImages} onSelect={handleSelect} />;
};
